import React, { useEffect, useRef } from "react";
import { bool } from "prop-types";
import { registerLocale, setDefaultLocale } from "react-datepicker-4.8.0";
import { MainContainerContext } from "pages/_components/MainContainer";
import { resizableRoute as resizableComponent } from "pages/_components/Resizable";
import CustomDatePicker from "pages/_components/fields/datepicker/latest-version/CustomDatePicker";
import MobileCustomDatePickerInput from "pages/_components/fields/datepicker/MobileCustomDatePickerInput";
import es from "date-fns-2.29.3/locale/es";
import en from "date-fns-2.29.3/locale/en-US";
import pt from "date-fns-2.29.3/locale/pt";
import { useSelector } from "react-redux";

export const DatePickerWithCustomInputLatestVersion = resizableComponent((props) => {
    const { lang } = useSelector((state) => state.i18n);
    const locate = { es, en, pt };
    const startRef = useRef();
    const { isMobile } = props;
    const onKeyDown = (e) => {
        if (e.keyCode === 9 || e.which === 9) {
            startRef.current.setOpen(false);
        }
    };

    useEffect(() => {
        registerLocale(lang, locate[lang]);
        setDefaultLocale(locate[lang]);
    }, []);

    if (isMobile) {
        return (
            <MainContainerContext.Consumer>
                {(ref) => (
                    <CustomDatePicker
                        {...props}
                        customInput={<MobileCustomDatePickerInput />}
                        onKeyDown={(e) => e.preventDefault()}
                        isMobile={isMobile}
                        viewContentRef={ref}
                        locate={es}
                    />
                )}
            </MainContainerContext.Consumer>
        );
    }

    return <CustomDatePicker {...props} isMobile={isMobile} ref={startRef} onKeyDown={onKeyDown} locate={es} />;
});

DatePickerWithCustomInputLatestVersion.propTypes = {
    isMobile: bool.isRequired,
};

export default DatePickerWithCustomInputLatestVersion;
